import { createReducer } from "@reduxjs/toolkit";
import { createExternalTeacher, resetCreateExternalTeacher } from "./create-external-teacher";
import type { CreationState } from "@redux/state/shared-types";

const initialState: CreationState = {
  processing: "idle",
  justCreatedId: null,
};

export const createExternalTeacherReducer = createReducer(initialState, builder => {
  builder
    .addCase(createExternalTeacher.pending, state => {
      state.processing = "pending";
    })
    .addCase(createExternalTeacher.fulfilled, (state, action) => {
      state.processing = "success";
      state.justCreatedId = action.payload;
    })
    .addCase(createExternalTeacher.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetCreateExternalTeacher, () => {
      return initialState;
    });
});
